import React from 'react';
import { Box, Card } from '@mui/material';

/**
 * Perspective tilt on hover — reads as “3D” without WebGL.
 */
export default function HoverCard3D({ children, onClick, sx, cardSx }) {
  return (
    <Box
      sx={{
        perspective: '1100px',
        height: '100%',
        ...sx,
      }}
    >
      <Card
        elevation={0}
        onClick={onClick}
        sx={{
          height: '100%',
          transformStyle: 'preserve-3d',
          transition:
            'transform 0.45s cubic-bezier(0.2, 0.85, 0.25, 1), box-shadow 0.45s',
          transform: 'rotateX(0deg) rotateY(0deg) translateZ(0)',
          '&:hover': {
            transform: 'rotateX(4deg) rotateY(-7deg) translateZ(14px)',
            boxShadow:
              '0 28px 56px -16px rgba(15, 23, 42, 0.35), 0 0 0 1px rgba(255,255,255,0.06) inset',
          },
          ...cardSx,
        }}
      >
        {children}
      </Card>
    </Box>
  );
}
